import { inject } from "@angular/core";
import { CanDeactivateFn } from "@angular/router";
import { from } from "rxjs";
import { ConfirmDialogService } from "./confirm-dialog.service";

export interface HasUnsavedChanges {
  isDirty: boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (
  component,
) => {
  const confirmDialog = inject(ConfirmDialogService);
  if (!component.isDirty) return true;
  return from(
    confirmDialog.confirm({
      title: "Unsaved changes",
      message: "You have unsaved changes. Leave without saving?",
      confirmText: "Leave",
      cancelText: "Stay",
      destructive: true,
    }),
  );
};
